"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Representation of single line of receipt printed by cash desk.
 * @author VRu
 */


var ReceiptLine =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(ReceiptLine, _StateDomainObject_1$);

  /**
   * @param id ID of receipt
   * @param externalId external ID of receipt
   * @param transactionId identification of receipt
   * @param line number of line on receipt this entity represents
   * @param productId external id of product referred by the receipt
   * @param siteId external id of site referred by the receipt
   * @param promotionId external id of promotion referred by the receipt or null if the product was not sold in promotion
   * @param cashdeskId id of device that created the receipt
   * @param datetime date and of creation of the receipt
   * @param amount number of units sold
   * @param saleValueWithoutVat total sale value
   * @param vat VAT corresponding to saleValueWithoutVat
   * @param created date of beginning of day the receipt was created (in UTC). Alignment to start of a day is important for
   *     indexing and further processing of receipts.
   * @param stateFlags
   */
  function ReceiptLine(id, externalId, transactionId, line, productId, siteId, promotionId, cashdeskId, datetime, amount, saleValueWithoutVat, vat, created, stateFlags) {
    var _this;

    _classCallCheck(this, ReceiptLine);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReceiptLine).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.transactionId = transactionId;
    _this.line = line;
    _this.productId = productId;
    _this.siteId = siteId;
    _this.promotionId = promotionId;
    _this.cashdeskId = cashdeskId;
    _this.datetime = datetime;
    _this.amount = amount;
    _this.saleValueWithoutVat = saleValueWithoutVat;
    _this.vat = vat;
    _this.created = created;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return ReceiptLine;
}(StateDomainObject_1.StateDomainObject);

exports.ReceiptLine = ReceiptLine;

ReceiptLine.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReceiptLine.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    transactionId: builder.str('transactionId'),
    line: builder.num('line'),
    productId: builder.str('productId'),
    siteId: builder.str('siteId'),
    promotionId: builder.opt(builder.str('promotionId')),
    cashdeskId: builder.num('cashdeskId'),
    datetime: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    amount: builder.bigNum('amount'),
    saleValueWithoutVat: builder.opt(builder.bigNum('saleValueWithoutVat')),
    vat: builder.opt(builder.bigNum('vat')),
    created: builder.date('created'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();